module.exports = __webpack_public_path__ + "img/home-screenshot1.fcd6896f.png";